import { useHistory } from 'lib/router'
import { useStore } from 'state/store'
import { Home } from 'views/Home'

const CompaniesHomeContainer = () => {
  const workspaceId = useStore(state => state.workspace.id)
  const history = useHistory()

  return (
    <Home
      step1={{
        title: 'pmportal.home.step1.titleEmployees',
        text: 'pmportal.home.step1.textEmployees',
        linkLabel: 'pmportal.home.step1.buttonEmployees',
        linkName: `/workspaces/${workspaceId}/employees`,
      }}
      step2={{
        title: 'pmportal.home.step2.title',
        text: 'pmportal.home.step2.text',
        linkLabel: 'pmportal.home.step2.button',
        linkName: `/workspaces/${workspaceId}/settings/billing`,
      }}
      step3={{
        title: 'pmportal.home.step3.title',
        text: 'pmportal.home.step3.text',
        linkLabel: 'pmportal.home.step3.button',
        linkName: `/workspaces/${workspaceId}/incentives`,
      }}
      onLinkClick={linkName => {
        history.push(linkName)
      }}
    />
  )
}

export default CompaniesHomeContainer
